export default "__VITE_ASSET__B6V4673s__"